import axios from "axios";
import { useState } from "react";
import { useSelector } from "react-redux";
import apiUrl from "../libs/baseUrl";
import { errorHandeling } from "../errorHandeling";

function useFetchAuthMeTemp() {

const token = useSelector(state => state.user.token);

//====State start here====
const [authMeData,setAuthMeData] = useState(null);

const [vacationData , setVacationData] = useState([])

const [should_add_relatives,setShould_add_relatives] = useState(false);

const [realativesData,setRealativesData] = useState([]);

const [loading,setLoading] = useState(false)

const [error,setError] = useState(null);
//====State end here====

//====Event handler start here====
const fetchAuthmeTemp = async()=>{
    setLoading(true);
    try {
        const response = await axios.post(`${apiUrl}/auth/me`, 
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        setAuthMeData(response.data?.data);
        setVacationData(response.data?.data?.vacations || []);
        setShould_add_relatives(response.data?.data?.should_add_relatives || false );
        setRealativesData(response.data?.data?.relatives || [] );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(errorHandeling(error));
      }
}


//====Event handler end here====
    
  return { fetchAuthmeTemp , authMeData , vacationData , should_add_relatives , realativesData , loading , error , setError };
}

export default useFetchAuthMeTemp;